import { Route, Switch } from "react-router-dom";
import ConciliacaoBancariaListagemPages from "./Listagem";

function ConciliacaoBancariaPages() {
  return (
    <Switch>
      <Route
        path="/financeiro/conciliacao-bancaria"
        component={ConciliacaoBancariaListagemPages}
      />
    </Switch>
  );
}

export default ConciliacaoBancariaPages;
